import React from 'react';
import { Segment, Header, Message } from 'semantic-ui-react';
import TokensTable from '../../components/TokensTable';
import QuotaProgressBar from '../../components/QuotaProgressBar';
import TodayStats from '../../components/TodayStats';

const Token = () => (
  <>
    <Segment>
      <TodayStats />
    </Segment>
    <Segment>
      <QuotaProgressBar />
    </Segment>
    <Segment>
      <Message warning>
        请妥善保管你的 API 令牌，不要将其泄露给他人。令牌一旦泄露，请立即删除并重新创建。
      </Message>
      <Header as='h3'>我的令牌</Header>
      <TokensTable/>
    </Segment>
  </>
);

export default Token;
